import { cn } from '@Utils/cn';
import sanitizeHtml from 'sanitize-html';

export default function RichText({
  content,
  className,
}: {
  content: string;
  className?: string;
}) {
  const sanitizedHtml = sanitizeHtml(content, {
    allowedTags: [
      'b',
      'i',
      'em',
      'strong',
      'a',
      'p',
      'br',
      'ul',
      'ol',
      'li',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'div',
    ],
    allowedAttributes: {
      'a': ['href'],
      '*': ['class'],
    },
  });

  return (
    <div
      className={cn('prose prose-sm', className)}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
}
